import { Card, Icon, LoadingSpinner, Modal, Notification, Tooltip, ButtonGroup, Button } from 'pepsico-ds'
import React, { useEffect, useState, useRef } from 'react'
import { formatIntoDropdownData, formatNumberWithCommas, splitValueWithUnit, handleDomToImgDownloadPdf } from '../../utils/utils'
import { Col, message, Row } from 'antd'
import SingleSelectDropdown from '../Dropdown/SingleSelectDropdown'
import MultiSelectDropdown from '../Dropdown/MultiSelectDropdown'
import CustomPieChart from '../Charts/SustainabilityChart/CustomPieChart'
import NoData from '../NoData/NoData'
import { getCategoriesLevel2ForSustainability, getSectors, getYears } from '../../pages/KPIOverview/KpiUtils'
import { suppliersMockData, sustainabilityData, regenDropdownData, legendColor, ladderScoreLegend } from "../../mocks/sustainabilityData";
import { useDispatch, useSelector } from 'react-redux'
import { FetchSupplierNamesAtion, FetchSustainabilityAction, FetchSustainabilityFilterDetailsAtion } from '../../redux/action/SustainabilityAction'
import InfoIcon from '../Icons/InfoIcon'
import { localStoreKeys } from '../../constants/localStoreKeys';
import { trackModalView, getModalAttributes } from '../../utils/fullstory-utils';
import reset_icon from "../../../src/assets/reset_icon.svg";
import CustomButtons from '../Cards/CustomButtons'
import FilterWithSuppliers from './FilterWithSuppliers';
import DropdownWithIcons from './DropdownWithIcons'
import { useToast } from '../../components/Toast/ToastContext';
import Vector from '../../assets/Vector.png'
import EDF_checked from "../../../src/assets/EDF_checked.svg";
import { staticNotes } from '../../constants/staticNotes';

const defaultYear = window.YEAR

function SustainabilityLegend({ color, text, key }) {
    return (
        <Col xs={24} sm={24} md={8} lg={8} xl={8} key={key}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <circle cx="6" cy="6" r="6" fill={color} />
                </svg>
                <div className="sustainability-legend-text">{text}</div>
            </div>
        </Col>
    )
}


function LadderScoreLegend({ color, title, value, text, key }) {
    return (
        // <Col xs={24} sm={24} md={24} lg={24} xl={24} key={key}>
        <div className='ladder-score-legend' key={key}>
            {/* <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <circle cx="6" cy="6" r="6" fill={color} />
                </svg> */}
            <div className="sustainability-legend-text">
                <b style={{ backgroundColor: color, padding: '2px 5px', color: '#fff', borderRadius: 2 }}>{title.toUpperCase()}</b>
                <div><b>{value}</b> {text}</div>
            </div>
        </div>
        // </Col>
    )
}


function SustainabilityCard({ item, isValid }) {
    return (
        <Card style={{ borderRadius: 10, height: '100%', padding: "1rem" }}>
            <div className="sustainability-modal-leader-text" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }} >
                <span>{item?.title}</span>
                {isValid && <InfoIcon text={isValid} direction='left' />}
            </div>
            <div style={{ width: '90%', display: 'flex', justifyContent: 'space-between' }}>
                <div className="sustainability-modal-currenthyear-value" style={{ color: item?.colour }}>{item?.currentYearValue}</div>
                <div>
                    <div className="sustainability-modal-lastyear-value">LY <b>{item?.lastYearValue}</b></div>
                    <div className="sustainability-modal-status" style={{ backgroundColor: item?.colour }}>{item?.status}</div>
                </div>
            </div>
            <div>
                <div className='spend-modal-total-spend-text'>{item?.message}</div>
            </div>
            {/* <div className="modal-update-frequesncy">Data As On: {item.lastUpdate} | Refresh Frequency: {item.refreshFrequency}</div> */}
        </Card>
    )
}


function SustainabilityModal({ openModal, setOpenModal, userData, selectedYear, capability, userDataLandingPage, landingPageFilters }) {
    // Track modal view when opened
    const MODAL_TITLE = 'Sustainability';

    useEffect(() => {
        if (openModal) {
            try {
                trackModalView(`${MODAL_TITLE} ${capability}`, 'view');
            } catch (error) {
                // Silent fail for tracking errors to not disrupt user experience
            }
        }
    }, [openModal, capability]);

    
    const handleClose = () => {
        try {
            trackModalView(`${MODAL_TITLE} ${capability}`, 'close');
        } catch (error) {
            // Silent fail for tracking errors
        }
        setOpenModal(false);
    };
    const dispatch = useDispatch()
    const [yearSelected, setYearSelected] = useState("")
    const [regenSelected, setRegenSelected] = useState([])
    const [years, setYears] = useState([])
    const [sectors, setSectors] = useState([])
    const [sectorSelected, setSectorSelected] = useState([])
    const [categoriesLevel2, setCategoriesLevel2] = useState([])
    const [categoryL2Selected, setCategoryL2Selected] = useState([])
    const [suppliersSelected, setSuppliersSelected] = useState([])
    const [allSuppliers, setAllSuppliers] = useState([])
    const [allRegens, setAllRegens] = useState([])
    const [loader, setLoader] = useState(true)
    const [sustainabilityKpiData, setSustainabilityKpiData] = useState({})
    const [buttonGroupItems, setButtonGroupItems] = useState([])

    const suppliersNames = useSelector((state) => state.getSupplierNames);//suppliersMockData
    const sustainabilityDetailViewData = useSelector((state) => state.getSustainabilityDetailReducer);
    const sustainabilityFlterDetailsData = useSelector((state) => state.getSustainabilityFilterDetailsReducer)
    const feedbackFormUrl = useSelector((state) => state?.localData?.data[localStoreKeys.feedbackFormUrl]);
    const maxDateForApps = useSelector((state) => state?.localData?.data[localStoreKeys.maxDateForApps]);
    const isLoading = useSelector((state) => state?.loader?.isLoading);

    
    const getSustainabilityDataFromFilters = (value) => {
        setSustainabilityKpiData(value?.data)
        setSuppliersSelected(value?.suppliers)
        setRegenSelected(value?.regen)
        setLoader(false)
        const appList = sustainabilityDetailViewData?.apps
        if (appList && appList.length > 0) {
            const tempbuttonGroupItems = appList
                ?.filter(item => item.isActive)
                .map(item => ({
                    label: item.app,
                    onClick: () => window.open(item.url, "_blank"),
                }));

            setButtonGroupItems(tempbuttonGroupItems)
        }
    }
    

    
    function addColorsToLegends(legends, colors) {
        const temp = legends?.map(legend => {
            const trimmedName = legend.name.trim();
            const color = colors[trimmedName] || '#000000';
            return { name: legend.name, value: parseFloat(legend.value), color: color, numericValue: legend.value };
        })
        let filterTemp = temp?.filter(item => item.value !== 'NaN' && item.value > 0);
        const namesToRemove = ['Regen Ag', 'Regen Ag projects'];
        if (regenSelected?.[0] && regenSelected?.[0]?.displayText?.toLowerCase() === 'pack') {
            filterTemp = filterTemp?.filter(item => !namesToRemove.includes(item.name));
        }
        return filterTemp ? filterTemp : []
    }

    const filterSustainabilityData = sustainabilityKpiData?.pieChartDataDtoList
    // console.log("filterSustainabilityData", filterSustainabilityData);

    const sustainabilityDataSliced = sustainabilityKpiData?.kpiDetailCardDtoList?.slice(3)
    const sustainabilityDataFirstItem = sustainabilityKpiData?.kpiDetailCardDtoList?.[0]
    const sustainabilityDataSecondItem = sustainabilityKpiData?.kpiDetailCardDtoList?.[1]
    const sustainabilityDataThirdItem = sustainabilityKpiData?.kpiDetailCardDtoList?.[2]
    const pieChartData = addColorsToLegends(filterSustainabilityData, legendColor);
    const isEDFIntegrated = sustainabilityKpiData?.edfintegrated;
    const appOwnersList = sustainabilityKpiData?.owners
    const emailList = appOwnersList?.map(contact => contact.emailId).join(', ');

    const sustainabilityRef = useRef()
    const sustainabilityChartRef = useRef()
    
    
    const validateCards = (value) => {
        if (value?.currentYearValue === 'N/A' && value?.lastYearValue === 'N/A') {//&& value.lastUpdate === 'N/A' && value.refreshFrequency === 'N/A'
            if (value?.title.toLowerCase().includes('regen')) {
                return "This KPI applies exclusively to \n Ingredient Suppliers. If a user \nselects Pack Type Suppliers,this \nKPI will not be calculated."
            }
            if(value?.title.toLowerCase().includes('fuel') && value?.messageFlag == true){
                return "Renewable Fuel % is not calculated when multiple Supplier Types are selected. Please select one Supplier Type to see this KPI. This KPI make more sense at individual supplier level, any aggregation done is for simulation purpose. Use Supplier filter to see more accurate metrices."
            }
            if(value?.title.toLowerCase().includes('electricity') && value?.messageFlag == true){
                return "Renewable Electricity % is not calculated when multiple Supplier Types are selected. Please select one Supplier Type to see this KPI. This KPI make more sense at individual supplier level, any aggregation done is for simulation purpose. Use Supplier filter to see more accurate metrices."
            }
            if (value?.title.toLowerCase().includes('renewable') && suppliersSelected?.length > 1) {
                // return "This KPI is available only at the \nindividual supplier level."
                return "This KPI make more sense at individual supplier level, any aggregation done is for simulation purpose. Use Supplier filter to see more accurate metrices."
            }
            
        }
        return null
    }

    const { showToast } = useToast();


    
    const checkPDFDownloaded = () => {}
    

    
    return (
        <Modal
            onCloseModal={handleClose}
            primaryButtonProps={{
                onClick: handleClose,
                size: "medium",
                text: "Close",
                variant: "primary",
            }}
            showPrimaryButton={true}
            showLink={false}
            showSecondaryButton={false}
            showTertiaryButton={false}
            showSlot={true}
            showModal={openModal}
            showAuxiliaryButton={false}
            type="XL"
            closeOnOutsideClick={false}
            hideCloseButton={false}
            {...getModalAttributes(`${MODAL_TITLE} ${capability}`)}
        >
            <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                <div ref={sustainabilityRef}>
                    <div className="modal-title" style={{ fontSize: 24, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span style={{width: '100%'}}>
                            {userData?.FirstName}, the Leader Ladder Sustainability Score for the Suppliers in your Category is
                            <b style={{ color: sustainabilityDataFirstItem?.colour, marginLeft: 10 }}>{formatNumberWithCommas(sustainabilityDataFirstItem?.currentYearValue)}</b>
                            {
                                isEDFIntegrated &&
                                <Tooltip direction="bottom" text={staticNotes.EDF_NOTE}>
                                    <img src={EDF_checked} alt='image' style={{ width: '18px', height: '22px', marginLeft: "8px", overflow:"visible", marginBottom: "7px" }} />
                                </Tooltip>
                            }
                        </span>
                        {
                            isLoading ? (
                                <></>
                            ) :                    
                            <>
                                {/* <ButtonGroup
                                    style={{ marginRight: '2rem' }}
                                    className="buy-con-button-group"
                                    items={buttonGroupItems}
                                    size="small"
                                /> */}
                                
                            
                                <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    <CustomButtons isModal={true} appList={sustainabilityKpiData?.apps} />
                                    {/* <button onClick={() => handleDomToImgDownloadPdf(sustainabilityRef, "Sustainability_Modal")}>PDF</button> */}
                                    <span style={{float: 'right', position: 'relative', right: '2rem', bottom: '0.4rem'}}>
                                        <DropdownWithIcons modalRef={sustainabilityRef} kpiName={"Sustainability_Modal"} isModal={true} checkPDFDownloaded={checkPDFDownloaded}/>
                                    </span>
                                </span>
                            
                            </>
                        }

                    </div>
                    <div className="modal-update-frequesncy">Data As On: {sustainabilityKpiData?.lastUpdate} | Refresh Frequency: {sustainabilityKpiData?.refreshFrequency}</div>
                    {/* <Row gutter={[10, 10]} justify="start" style={{ width: "100%" }}> COMMENTED AFTER COMMON SUPPLIER FILTER
                        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                            <MultiSelectDropdown className={"buy-con-dropdown-modal"} placeholder="Sector" label="Sector" childList={sectors} selectedValue={sectorSelected} setSelectedValue={onSectorChange} />
                        </Col>
                        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                            <MultiSelectDropdown className={"buy-con-dropdown-modal"} placeholder="Category" label="Category" childList={categoriesLevel2} selectedValue={categoryL2Selected} setSelectedValue={onCategoryL2Change} />
                        </Col>
                        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                            <MultiSelectDropdown className={"buy-con-dropdown-modal"} placeholder="Supplier Type" label="Supplier Type" childList={allRegens} selectedValue={regenSelected} setSelectedValue={onRegenChange} />
                        </Col>
                        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                            <MultiSelectDropdown className={"buy-con-dropdown-modal"} placeholder="Supplier" label="Supplier" childList={allSuppliers} selectedValue={suppliersSelected} setSelectedValue={onSupplierChange} />
                        </Col>
                        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                            <SingleSelectDropdown className={"buy-con-dropdown-modal"} placeholder="Years" label="Year" childList={years} selectedValue={yearSelected} setSelectedValue={onYearChange} />
                        </Col>
                    </Row> */}
                    <FilterWithSuppliers selectedYear={selectedYear} capability={capability} userData={userDataLandingPage} onParentCallback={getSustainabilityDataFromFilters} landingPageFilters={landingPageFilters} setLoader={setLoader} />
                    <br />
                    <div style={{marginTop: '0.5rem'}}></div>
                    {/* <Row justify="end"> COMMENTED AFTER COMMON SUPPLIER FILTER
                        <button className="reset-button" onClick={onFiltersReset}  style={{ marginRight: '1.2rem' }}>
                            <img src={reset_icon} className="reset_icon" alt="Reset Icon" />
                            <span>Reset Filters</span>
                        </button>
                    </Row> */}
                    {
                        (loader || isLoading) ?
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 300 }}>
                                <LoadingSpinner size={{ height: '80px', width: '80px' }} />
                            </div>
                            :
                            <>
                                {/* <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly", height: "100%" }}>
                                        <div style={{ fontSize: 64, fontWeight: "700", color: '#3A3A3A' }}>4</div>
                                        <div style={{ fontSize: 14, fontWeight: "500", color: '#616161' }}>Reports Pending Review</div>
                                    </div>
                                </Col>
                                <div className="modal-divider-verticle" />
                                <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly", height: "100%" }}>
                                        <div style={{ display: 'flex', alignItems: "end" }}>
                                            <div style={{ fontSize: 32, fontWeight: "700", color: '#3A3A3A', lineHeight: '1em' }}>{splitValueWithUnit("$195.9BN")['numericValue']}</div>
                                            <div style={{ fontSize: 16, fontWeight: "700", color: '#3A3A3A' }}>{splitValueWithUnit("$195.9BN")['unit']}</div>
                                        </div>
                                        <div style={{ fontSize: 14, fontWeight: "500", color: '#616161' }}>Market Size</div>
                                    </div>
                                </Col>
                                <div className="modal-divider-verticle" />
                                <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly", height: "100%" }}>
                                        <div style={{ fontSize: 32, fontWeight: "700", color: '#3A3A3A' }}>7.16%</div>
                                        <div style={{ fontSize: 14, fontWeight: "500", color: '#616161' }}>CAGR</div>
                                    </div>
                                </Col>
                            </Row>
                            <br /> */}
                                <Row gutter={[20, 20]} justify={"start"} style={{ width: "100%" }}>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        <Card>
                                            <div style={{ fontSize: 14, fontWeight: 700, width: '100%' }}>Sustainability Scores Legend</div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                {
                                                    ladderScoreLegend?.map((item, index) => {
                                                        return <LadderScoreLegend key={index + 1} color={item.color} title={item.title} text={item.text} value={item.value} />
                                                    })
                                                }
                                            </div>
                                        </Card>
                                    </Col>
                                    <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                                        <div ref={sustainabilityChartRef}>
                                            <Card style={{ width: '100%', height: '100%', borderRadius: 10 }}>
                                                <Row gutter={[20, 20]} style={{ width: '100%' }}>
                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                        <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                                                            <div className="sustainability-modal-leader-text">{sustainabilityDataFirstItem?.title}</div>
                                                            <InfoIcon text={"The Sustainability Leader Ladder Score helps to tailor our approach \n and meet suppliers where they are on their sustainability journey."} />
                                                            {/* <span style={{float: 'right'}}>
                                                                <DropdownWithIcons modalRef={sustainabilityChartRef} kpiName={"Sustainability Leader Ladder Score"} checkPDFDownloaded={checkPDFDownloaded}/>
                                                            </span> */}
                                                        </div>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                                                        <div>
                                                            {
                                                                sustainabilityDataFirstItem ?
                                                                    <div style={{ width: '90%', display: 'flex', justifyContent: 'space-between' }}>
                                                                        <div className="sustainability-modal-currenthyear-value" style={{ color: sustainabilityDataFirstItem?.colour }}>{sustainabilityDataFirstItem?.currentYearValue}</div>
                                                                        <div>
                                                                            <div className="sustainability-modal-lastyear-value">LY <b>{sustainabilityDataFirstItem?.lastYearValue}</b></div>
                                                                            <div className="sustainability-modal-status" style={{ backgroundColor: sustainabilityDataFirstItem?.colour }}>{sustainabilityDataFirstItem?.status}</div>
                                                                        </div>
                                                                    </div>
                                                                    : <NoData />
                                                            }

                                                        </div>
                                                        {/* <div className="modal-update-frequesncy">Data As On: {sustainabilityDataFirstItem?.lastUpdate} | Refresh Frequency: {sustainabilityDataFirstItem?.refreshFrequency}</div> */}
                                                        {
                                                            pieChartData?.length > 0 ?
                                                                <div style={{ marginTop: 20 }}>
                                                                    <div className="sustainability-modal-data-source"><b>Data Sources</b></div>
                                                                    <Row gutter={[10, 10]}>
                                                                        {
                                                                            pieChartData?.map((item, index) => {
                                                                                return (<SustainabilityLegend color={item.color} text={item.name} key={index + 1} />)
                                                                            })
                                                                        }
                                                                    </Row>
                                                                </div>
                                                                :
                                                                ''
                                                        }
                                                    </Col>
                                                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                        <div className="sustainability-modal-leader-text" style={{ fontSize: 14 }}>Data Sources Weighted Distribution</div>
                                                        {
                                                            pieChartData?.filter(item => item.value !== 0).length > 0 ? pieChartData?.length > 0 ?
                                                                <CustomPieChart data={pieChartData} />
                                                                : <NoData /> : <NoData />
                                                        }
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </div>
                                    </Col>
                                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                        <div style={{ height: 'calc(100%/2 - 10px)' }}>
                                            {
                                                sustainabilityDataSecondItem ?
                                                    <SustainabilityCard item={sustainabilityDataSecondItem} isValid={validateCards(sustainabilityDataSecondItem)} />
                                                    : <NoData />
                                            }

                                        </div>
                                        <br />
                                        <div style={{ height: 'calc(100%/2 - 10px)' }}>
                                            {
                                                sustainabilityDataThirdItem ?
                                                    <SustainabilityCard item={sustainabilityDataThirdItem} isValid={validateCards(sustainabilityDataThirdItem)} />
                                                    : <NoData />
                                            }

                                        </div>
                                    </Col>
                                    {
                                        sustainabilityDataSliced?.length > 0 ? sustainabilityDataSliced?.map(item => {
                                            const isValid = validateCards(item);
                                            return <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                <SustainabilityCard item={item} isValid={isValid} />
                                            </Col>
                                        }) :
                                            <NoData />
                                    }
                                </Row>
                                <br />
                                <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#0078A7', padding: 10, borderRadius: 5, width: 'fit-content' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M11 7.00195H13V9.00195H11V7.00195ZM11 11.002H13V17.002H11V11.002ZM12 2.00195C6.48 2.00195 2 6.48195 2 12.002C2 17.522 6.48 22.002 12 22.002C17.52 22.002 22 17.522 22 12.002C22 6.48195 17.52 2.00195 12 2.00195ZM12 20.002C7.59 20.002 4 16.412 4 12.002C4 7.59195 7.59 4.00195 12 4.00195C16.41 4.00195 20 7.59195 20 12.002C20 16.412 16.41 20.002 12 20.002Z" fill="white" />
                                        </svg>
                                        <div className="notification-container" style={{width: '100%'}}>
                                            Sustainability scores are calculated at the Sector Level, and users are not able to drill down to the Business Unit / Market level
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <div className="spend-modal-manage-spend" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", width: '100%' }}>
                                    <div style={{width: '100%'}}>Please reach out to {appOwnersList?.map((contact, index) => (
                                        <React.Fragment key={index}>
                                            <a href={`mailto:${contact.emailId}`} style={{ color: "#005cbc", textDecoration: "None" }}>{contact.emailId}</a>
                                            {index < appOwnersList.length - 1 && ', '}
                                        </React.Fragment>
                                    ))} for any query on the data displayed.</div>
                                    <div style={{width: '100%'}}>Please fill in <a href={feedbackFormUrl} target="_blank" style={{ color: "#005cbc", textDecoration: "None" }}>this form</a> for any feedback related to Procurement Hub.</div>
                                </div>
                            </>
                    }
                    <br/>
                </div>
            </div>
        </Modal>
    )
}

export default SustainabilityModal